// extracted by mini-css-extract-plugin
export var black = "_29-6";
export var brand = "_29-1";
export var ddefault = "_29-0";
export var error = "_29-3";
export var gray = "_29-2";
export var highContrast = "_29-8";
export var outline = "_29-7";
export var success = "_29-5";
export var warning = "_29-4";